/*==============================================================================
  Currency converter
==============================================================================*/
window.moneyFormats = {
  USD: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': '${{amount_no_decimals}} <span class="currency-country-code">USD</span>'
  },
  EUR: {
    'money_format': '&euro;{{amount_no_decimals}}',
    'money_with_currency_format': '&euro;{{amount_no_decimals}} <span class="currency-country-code">EUR</span>'
  },
  GBP: {
    'money_format': '&pound;{{amount_no_decimals}}',
    'money_with_currency_format': '&pound;{{amount_no_decimals}} <span class="currency-country-code">GBP</span>'
  },
  CAD: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': '${{amount_no_decimals}} <span class="currency-country-code">CAD</span>'
  },
  ALL: {
    'money_format': 'Lek {{amount_no_decimals}}',
    'money_with_currency_format': 'Lek {{amount_no_decimals}} <span class="currency-country-code">ALL</span>'
  },
  DZD: {
    'money_format': 'DA {{amount_no_decimals}}',
    'money_with_currency_format': 'DA {{amount_no_decimals}} <span class="currency-country-code">DZD</span>'
  },
  AOA: {
    'money_format': 'Kz{{amount_no_decimals}}',
    'money_with_currency_format': 'Kz{{amount_no_decimals}} <span class="currency-country-code">AOA</span>'
  },
  ARS: {
    'money_format': '${{amount_with_comma_separator}}',
    'money_with_currency_format': '${{amount_with_comma_separator}} <span class="currency-country-code">ARS</span>'
  },
  AMD: {
    'money_format': '{{amount_no_decimals}} AMD',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">AMD</span>'
  },
  AWG: {
    'money_format': 'Afl{{amount_no_decimals}}',
    'money_with_currency_format': 'Afl{{amount_no_decimals}} <span class="currency-country-code">AWG</span>'
  },
  AUD: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': '${{amount_no_decimals}} <span class="currency-country-code">AUD</span>'
  },
  BBD: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': '${{amount_no_decimals}} <span class="currency-country-code">Bds</span>'
  },
  AZN: {
    'money_format': 'm.{{amount_no_decimals}}',
    'money_with_currency_format': 'm.{{amount_no_decimals}} <span class="currency-country-code">AZN</span>'
  },
  BDT: {
    'money_format': 'Tk {{amount_no_decimals}}',
    'money_with_currency_format': 'Tk {{amount_no_decimals}} <span class="currency-country-code">BDT</span>'
  },
  BSD: {
    'money_format': 'BS${{amount_no_decimals}}',
    'money_with_currency_format': 'BS${{amount_no_decimals}} <span class="currency-country-code">BSD</span>'
  },
  BHD: {
    'money_format': '{{amount_no_decimals}}0 BD',
    'money_with_currency_format': '{{amount_no_decimals}}0 <span class="currency-country-code">BHD</span>'
  },
  BYR: {
    'money_format': 'Br {{amount_no_decimals}}',
    'money_with_currency_format': 'Br {{amount_no_decimals}} <span class="currency-country-code">BYR</span>'
  },
  BZD: {
    'money_format': 'BZ${{amount_no_decimals}}',
    'money_with_currency_format': 'BZ${{amount_no_decimals}} <span class="currency-country-code">BZD</span>'
  },
  BTN: {
    'money_format': 'Nu {{amount_no_decimals}}',
    'money_with_currency_format': 'Nu {{amount_no_decimals}} <span class="currency-country-code">BTN</span>'
  },
  BAM: {
    'money_format': 'KM {{amount_with_comma_separator}}',
    'money_with_currency_format': 'KM {{amount_with_comma_separator}} <span class="currency-country-code">BAM</span>'
  },
  BRL: {
    'money_format': 'R$ {{amount_with_comma_separator}}',
    'money_with_currency_format': 'R$ {{amount_with_comma_separator}} <span class="currency-country-code">BRL</span>'
  },
  BOB: {
    'money_format': 'Bs{{amount_with_comma_separator}}',
    'money_with_currency_format': 'Bs{{amount_with_comma_separator}} <span class="currency-country-code">BOB</span>'
  },
  BWP: {
    'money_format': 'P{{amount_no_decimals}}',
    'money_with_currency_format': 'P{{amount_no_decimals}} <span class="currency-country-code">BWP</span>'
  },
  BND: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': '${{amount_no_decimals}} <span class="currency-country-code">BND</span>'
  },
  BGN: {
    'money_format': '{{amount_no_decimals}} лв',
    'money_with_currency_format': '{{amount_no_decimals}} лв <span class="currency-country-code">BGN</span>'
  },
  MMK: {
    'money_format': 'K{{amount_no_decimals}}',
    'money_with_currency_format': 'K{{amount_no_decimals}} <span class="currency-country-code">MMK</span>'
  },
  KHR: {
    'money_format': 'KHR{{amount_no_decimals}}',
    'money_with_currency_format': 'KHR{{amount_no_decimals}}</span>'
  },
  KYD: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': '${{amount_no_decimals}} <span class="currency-country-code">KYD</span>'
  },
  XAF: {
    'money_format': 'FCFA{{amount_no_decimals}}',
    'money_with_currency_format': 'FCFA{{amount_no_decimals}} <span class="currency-country-code">XAF</span>'
  },
  CLP: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': '${{amount_no_decimals}} <span class="currency-country-code">CLP</span>'
  },
  CNY: {
    'money_format': '&#165;{{amount_no_decimals}}',
    'money_with_currency_format': '&#165;{{amount_no_decimals}} <span class="currency-country-code">CNY</span>'
  },
  COP: {
    'money_format': '${{amount_with_comma_separator}}',
    'money_with_currency_format': '${{amount_with_comma_separator}} <span class="currency-country-code">COP</span>'
  },
  CRC: {
    'money_format': '&#8353; {{amount_with_comma_separator}}',
    'money_with_currency_format': '&#8353; {{amount_with_comma_separator}} <span class="currency-country-code">CRC</span>'
  },
  HRK: {
    'money_format': '{{amount_with_comma_separator}} kn',
    'money_with_currency_format': '{{amount_with_comma_separator}} kn <span class="currency-country-code">HRK</span>'
  },
  CZK: {
    'money_format': '{{amount_with_comma_separator}} K&#269;',
    'money_with_currency_format': '{{amount_with_comma_separator}} <span class="currency-country-code">K&#269;</span>'
  },
  DKK: {
    'money_format': '{{amount_with_comma_separator}}',
    'money_with_currency_format': '<span class="currency-country-code">kr.</span>{{amount_with_comma_separator}}'
  },
  DOP: {
    'money_format': 'RD$ {{amount_no_decimals}}',
    'money_with_currency_format': 'RD$ {{amount_no_decimals}}'
  },
  XCD: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': 'EC${{amount_no_decimals}}'
  },
  EGP: {
    'money_format': 'LE {{amount_no_decimals}}',
    'money_with_currency_format': 'LE {{amount_no_decimals}} <span class="currency-country-code">EGP</span>'
  },
  ETB: {
    'money_format': 'Br{{amount_no_decimals}}',
    'money_with_currency_format': 'Br{{amount_no_decimals}} <span class="currency-country-code">ETB</span>'
  },
  XPF: {
    'money_format': '{{amount_no_decimals_with_comma_separator}} XPF',
    'money_with_currency_format': '{{amount_no_decimals_with_comma_separator}} <span class="currency-country-code">XPF</span>'
  },
  FJD: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': 'FJ${{amount_no_decimals}}'
  },
  GMD: {
    'money_format': 'D {{amount_no_decimals}}',
    'money_with_currency_format': 'D {{amount_no_decimals}} <span class="currency-country-code">GMD</span>'
  },
  GHS: {
    'money_format': 'GH&#8373;{{amount_no_decimals}}',
    'money_with_currency_format': 'GH&#8373;{{amount_no_decimals}}'
  },
  GTQ: {
    'money_format': 'Q{{amount_no_decimals}}',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">GTQ</span>'
  },
  GYD: {
    'money_format': 'G${{amount_no_decimals}}',
    'money_with_currency_format': '${{amount_no_decimals}} <span class="currency-country-code">GYD</span>'
  },
  GEL: {
    'money_format': '{{amount_no_decimals}} GEL',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">GEL</span>'
  },
  HNL: {
    'money_format': 'L {{amount_no_decimals}}',
    'money_with_currency_format': 'L {{amount_no_decimals}} <span class="currency-country-code">HNL</span>'
  },
  HKD: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': 'HK${{amount_no_decimals}}'
  },
  HUF: {
    'money_format': '{{amount_no_decimals_with_comma_separator}}',
    'money_with_currency_format': '{{amount_no_decimals_with_comma_separator}} <span class="currency-country-code">Ft</span>'
  },
  ISK: {
    'money_format': '{{amount_no_decimals}} kr',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">kr ISK</span>'
  },
  INR: {
    'money_format': 'Rs. {{amount_no_decimals}}',
    'money_with_currency_format': '<span class="currency-country-code">Rs.</span> {{amount_no_decimals}}'
  },
  IDR: {
    'money_format': '{{amount_with_comma_separator}}',
    'money_with_currency_format': 'Rp {{amount_with_comma_separator}}'
  },
  ILS: {
    'money_format': '{{amount_no_decimals}} NIS',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">NIS</span>'
  },
  JMD: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': '${{amount_no_decimals}} <span class="currency-country-code">JMD</span>'
  },
  JPY: {
    'money_format': '&#165;{{amount_no_decimals}}',
    'money_with_currency_format': '&#165;{{amount_no_decimals}} <span class="currency-country-code">JPY</span>'
  },
  JEP: {
    'money_format': '&pound;{{amount_no_decimals}}',
    'money_with_currency_format': '&pound;{{amount_no_decimals}} <span class="currency-country-code">JEP</span>'
  },
  JOD: {
    'money_format': '{{amount_no_decimals}}0 JD',
    'money_with_currency_format': '{{amount_no_decimals}}0 <span class="currency-country-code">JOD</span>'
  },
  KZT: {
    'money_format': '{{amount_no_decimals}} KZT',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">KZT</span>'
  },
  KES: {
    'money_format': 'KSh{{amount_no_decimals}}',
    'money_with_currency_format': 'KSh{{amount_no_decimals}}'
  },
  KWD: {
    'money_format': '{{amount_no_decimals}}0 KD',
    'money_with_currency_format': '{{amount_no_decimals}}0 <span class="currency-country-code">KWD</span>'
  },
  KGS: {
    'money_format': 'лв{{amount_no_decimals}}',
    'money_with_currency_format': 'лв{{amount_no_decimals}}'
  },
  LVL: {
    'money_format': 'Ls {{amount_no_decimals}}',
    'money_with_currency_format': 'Ls {{amount_no_decimals}} <span class="currency-country-code">LVL</span>'
  },
  LBP: {
    'money_format': 'L&pound;{{amount_no_decimals}}',
    'money_with_currency_format': 'L&pound;{{amount_no_decimals}} <span class="currency-country-code">LBP</span>'
  },
  LTL: {
    'money_format': '{{amount_no_decimals}} Lt',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">Lt</span>'
  },
  MGA: {
    'money_format': 'Ar {{amount_no_decimals}}',
    'money_with_currency_format': 'Ar {{amount_no_decimals}} <span class="currency-country-code">MGA</span>'
  },
  MKD: {
    'money_format': 'ден {{amount_no_decimals}}',
    'money_with_currency_format': 'ден {{amount_no_decimals}} <span class="currency-country-code">MKD</span>'
  },
  MOP: {
    'money_format': 'MOP${{amount_no_decimals}}',
    'money_with_currency_format': 'MOP${{amount_no_decimals}}'
  },
  MVR: {
    'money_format': 'Rf{{amount_no_decimals}}',
    'money_with_currency_format': 'Rf{{amount_no_decimals}} <span class="currency-country-code">MRf</span>'
  },
  MXN: {
    'money_format': '$ {{amount_no_decimals}}',
    'money_with_currency_format': '$ {{amount_no_decimals}} <span class="currency-country-code">MXN</span>'
  },
  MYR: {
    'money_format': 'RM{{amount_no_decimals}} MYR',
    'money_with_currency_format': 'RM{{amount_no_decimals}} <span class="currency-country-code">MYR</span>'
  },
  MUR: {
    'money_format': 'Rs {{amount_no_decimals}}',
    'money_with_currency_format': 'Rs {{amount_no_decimals}} <span class="currency-country-code">MUR</span>'
  },
  MDL: {
    'money_format': '{{amount_no_decimals}} MDL',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">MDL</span>'
  },
  MAD: {
    'money_format': '{{amount_no_decimals}} dh',
    'money_with_currency_format': 'Dh {{amount_no_decimals}} <span class="currency-country-code">MAD</span>'
  },
  MNT: {
    'money_format': '{{amount_no_decimals}} &#8366',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">MNT</span>'
  },
  MZN: {
    'money_format': '{{amount_no_decimals}} Mt',
    'money_with_currency_format': 'Mt {{amount_no_decimals}} <span class="currency-country-code">MZN</span>'
  },
  NAD: {
    'money_format': 'N${{amount_no_decimals}}',
    'money_with_currency_format': 'N${{amount_no_decimals}} <span class="currency-country-code">NAD</span>'
  },
  NPR: {
    'money_format': 'Rs{{amount_no_decimals}}',
    'money_with_currency_format': 'Rs{{amount_no_decimals}} <span class="currency-country-code">NPR</span>'
  },
  ANG: {
    'money_format': '&fnof;{{amount_no_decimals}}',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">NA&fnof;</span>'
  },
  NZD: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': '${{amount_no_decimals}} <span class="currency-country-code">NZD</span>'
  },
  NIO: {
    'money_format': 'C${{amount_no_decimals}}',
    'money_with_currency_format': 'C${{amount_no_decimals}} <span class="currency-country-code">NIO</span>'
  },
  NGN: {
    'money_format': '&#8358;{{amount_no_decimals}}',
    'money_with_currency_format': '&#8358;{{amount_no_decimals}} <span class="currency-country-code">NGN</span>'
  },
  NOK: {
    'money_format': 'kr {{amount_with_comma_separator}}',
    'money_with_currency_format': 'kr {{amount_with_comma_separator}} <span class="currency-country-code">NOK</span>'
  },
  OMR: {
    'money_format': '{{amount_with_comma_separator}} OMR',
    'money_with_currency_format': '{{amount_with_comma_separator}} <span class="currency-country-code">OMR</span>'
  },
  PKR: {
    'money_format': 'Rs.{{amount_no_decimals}}',
    'money_with_currency_format': '<span class="currency-country-code">Rs.</span>{{amount_no_decimals}} <span class="currency-country-code">PKR</span>'
  },
  PGK: {
    'money_format': 'K {{amount_no_decimals}}',
    'money_with_currency_format': 'K {{amount_no_decimals}} <span class="currency-country-code">PGK</span>'
  },
  PYG: {
    'money_format': 'Gs. {{amount_no_decimals_with_comma_separator}}',
    'money_with_currency_format': 'Gs. {{amount_no_decimals_with_comma_separator}} <span class="currency-country-code">PYG</span>'
  },
  PEN: {
    'money_format': 'S/. {{amount_no_decimals}}',
    'money_with_currency_format': 'S/. {{amount_no_decimals}} <span class="currency-country-code">PEN</span>'
  },
  PHP: {
    'money_format': '&#8369;{{amount_no_decimals}}',
    'money_with_currency_format': '&#8369;{{amount_no_decimals}} <span class="currency-country-code">PHP</span>'
  },
  PLN: {
    'money_format': '{{amount_with_comma_separator}} zl',
    'money_with_currency_format': '{{amount_with_comma_separator}} <span class="currency-country-code">zl PLN</span>'
  },
  QAR: {
    'money_format': 'QAR {{amount_with_comma_separator}}',
    'money_with_currency_format': 'QAR {{amount_with_comma_separator}}'
  },
  RON: {
    'money_format': '{{amount_with_comma_separator}} lei',
    'money_with_currency_format': '{{amount_with_comma_separator}} <span class="currency-country-code">lei RON</span>'
  },
  RUB: {
    'money_format': '&#1088;&#1091;&#1073;{{amount_with_comma_separator}}',
    'money_with_currency_format': '&#1088;&#1091;&#1073;{{amount_with_comma_separator}} <span class="currency-country-code">RUB</span>'
  },
  RWF: {
    'money_format': '{{amount_no_decimals}} RF',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">RWF</span>'
  },
  WST: {
    'money_format': 'WS$ {{amount_no_decimals}}',
    'money_with_currency_format': 'WS$ {{amount_no_decimals}} <span class="currency-country-code">WST</span>'
  },
  SAR: {
    'money_format': '{{amount_no_decimals}} SR',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">SAR</span>'
  },
  STD: {
    'money_format': 'Db {{amount_no_decimals}}',
    'money_with_currency_format': 'Db {{amount_no_decimals}} <span class="currency-country-code">STD</span>'
  },
  RSD: {
    'money_format': '{{amount_no_decimals}} RSD',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">RSD</span>'
  },
  SCR: {
    'money_format': 'Rs {{amount_no_decimals}}',
    'money_with_currency_format': 'Rs {{amount_no_decimals}} <span class="currency-country-code">SCR</span>'
  },
  SGD: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': '${{amount_no_decimals}} <span class="currency-country-code">SGD</span>'
  },
  SYP: {
    'money_format': 'S&pound;{{amount_no_decimals}}',
    'money_with_currency_format': 'S&pound;{{amount_no_decimals}} <span class="currency-country-code">SYP</span>'
  },
  ZAR: {
    'money_format': 'R {{amount_no_decimals}}',
    'money_with_currency_format': '<span class="currency-country-code">R</span> {{amount_no_decimals}} <span class="currency-country-code">ZAR</span>'
  },
  KRW: {
    'money_format': '&#8361;{{amount_no_decimals}}',
    'money_with_currency_format': '&#8361;{{amount_no_decimals}} <span class="currency-country-code">KRW</span>'
  },
  LKR: {
    'money_format': 'Rs {{amount_no_decimals}}',
    'money_with_currency_format': '<span class="currency-country-code">Rs</span> {{amount_no_decimals}} <span class="currency-country-code">LKR</span>'
  },
  SEK: {
    'money_format': '{{amount_no_decimals}} kr',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">kr SEK</span>'
  },
  CHF: {
    'money_format': 'SFr. {{amount_no_decimals}}',
    'money_with_currency_format': 'SFr. {{amount_no_decimals}} <span class="currency-country-code">CHF</span>'
  },
  TWD: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': '${{amount_no_decimals}} <span class="currency-country-code">TWD</span>'
  },
  THB: {
    'money_format': '{{amount_no_decimals}} &#xe3f;',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">&#xe3f; THB</span>'
  },
  TZS: {
    'money_format': '{{amount_no_decimals}} TZS',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">TZS</span>'
  },
  TTD: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': '${{amount_no_decimals}} <span class="currency-country-code">TTD</span>'
  },
  TND: {
    'money_format': '{{amount_no_decimals}}',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">DT</span>'
  },
  TRY: {
    'money_format': '{{amount_no_decimals}}TL',
    'money_with_currency_format': '{{amount_no_decimals}}<span class="currency-country-code">TL</span>'
  },
  UGX: {
    'money_format': 'Ush {{amount_no_decimals}}',
    'money_with_currency_format': 'Ush {{amount_no_decimals}} <span class="currency-country-code">UGX</span>'
  },
  UAH: {
    'money_format': '₴{{amount_no_decimals}}',
    'money_with_currency_format': '₴{{amount_no_decimals}} <span class="currency-country-code">UAH</span>'
  },
  AED: {
    'money_format': 'Dhs. {{amount_no_decimals}}',
    'money_with_currency_format': 'Dhs. {{amount_no_decimals}} <span class="currency-country-code">AED</span>'
  },
  UYU: {
    'money_format': '${{amount_with_comma_separator}}',
    'money_with_currency_format': '${{amount_with_comma_separator}} <span class="currency-country-code">UYU</span>'
  },
  VUV: {
    'money_format': '${{amount_no_decimals}}',
    'money_with_currency_format': '${{amount_no_decimals}}<span class="currency-country-code">VT</span>'
  },
  VEF: {
    'money_format': 'Bs. {{amount_with_comma_separator}}',
    'money_with_currency_format': 'Bs. {{amount_with_comma_separator}} <span class="currency-country-code">VEF</span>'
  },
  VND: {
    'money_format': '{{amount_no_decimals_with_comma_separator}}&#8363;',
    'money_with_currency_format': '{{amount_no_decimals_with_comma_separator}} <span class="currency-country-code">VND</span>'
  },
  XBT: {
    'money_format': '{{amount_no_decimals}} BTC',
    'money_with_currency_format': '{{amount_no_decimals}} <span class="currency-country-code">BTC</span>'
  },
  XOF: {
    'money_format': 'CFA{{amount_no_decimals}}',
    'money_with_currency_format': 'CFA{{amount_no_decimals}} <span class="currency-country-code">XOF</span>'
  },
  ZMW: {
    'money_format': 'K{{amount_no_decimals_with_comma_separator}}',
    'money_with_currency_format': 'ZMW{{amount_no_decimals_with_comma_separator}}'
  }
};
/**
 * Format a number to a specific format
 *
 * @param {Number} number - Value to format
 * @param {Number} precision - Amount of decimal points to show
 * @param {String} thousands - Thousands delimiter
 * @param {String} decimal - Decimal delimiter
 * @returns {String|Number}
 */

function formatWithDelimiters(number) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
  var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

  if (isNaN(number) || !number) {
    return 0;
  }

  var preciseNumber = (number / 100.0).toFixed(precision);
  var parts = preciseNumber.split(thousands);
  var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(thousands));
  var centsAmount = parts[1] ? decimal + parts[1] : '';
  return dollarsAmount + centsAmount;
}
/**
 * Convert a money value in cents to a formatted currency string
 *
 * @param {Number|String} cents
 * @param {String} format
 * @returns {String}
 */

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;


  switch (format.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2, ',', '.');
      break;

    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;

    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, '\'', '.');
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;

    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ', '.');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
  }

  return format.replace(placeholderRegex, value);
}
/**
 * Return the value of money in cents value
 *
 * @param {Number} moneyAmount - Money value of a price
 *                 eg: 1000
 * @param {String} format - Shop formatting of a price
 *                 eg: {{amount_no_decimals}}
 * @param {String} currency - Currency of a price
 *                 eg: 'CAD'
 * @returns {Number}
 * @private
 */


function getCentsValue(moneyAmount, format, currency) {
  var cents = 0; // Convert prices from float values to integers if needed, then convert
  if (format.indexOf('amount_no_decimals') !== -1) {
    cents = moneyAmount * 100;
  } else if (currency === 'JOD' || currency === 'KWD' || currency === 'BHD') {
    cents = moneyAmount / 10;
  } else {
    cents = moneyAmount;
  }

  return cents;
}
/**
 * Converts formatted money to a number
 *
 * @param {Element} priceEl
 * @returns {Number|String}
 */


function getMoneyValue(priceEl) {
  var price = priceEl.getAttribute('data-currency-original') || priceEl.textContent;
  var value = parseInt(price.replace(/[^0-9]/g, ''), 10);
  return !isNaN(value) ? value : '';
}

window.currencyConverter = {
  init: function init(settings) {
    this.defaults = {
      switcherSelector: '[data-currency-converter] .disclosure__button',
      priceSelector: 'span.money',
      shopCurrency: window.PXUTheme.currency.shop_currency,
      defaultCurrency: window.PXUTheme.currency.default_currency,
      displayFormat: window.PXUTheme.currency.display_format,
      moneyFormat: window.PXUTheme.currency.money_format,
      moneyFormatNoCurrency: window.PXUTheme.currency.money_format_no_currency,
      moneyFormatCurrency: window.PXUTheme.currency.money_format_currency,
    };
    this.options = this.defaults;
    this.moneyFormats = moneyFormats;
    this.storage = 'currency';
    this.currentCurrency = null;
    this.isInitialised = false;

    if (!window.Currency || this.isInitialised) return;
    $(this.options.switcherSelector).on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $currencySelector = $(this);
      window.currencyConverter.setCurrency($currencySelector.val());
    });
    this.currentCurrency = this._getStoredCurrency() || this.options.defaultCurrency;

    this.options.moneyFormat = '${{amount_no_decimals}} <span class="currency-country-code">AUD</span>';
    this.options.moneyFormatCurrency = '${{amount_no_decimals}} <span class="currency-country-code">AUD</span>';

    //gets negated with shopify multiple currency
    this.moneyFormats[this.options.shopCurrency].money_with_currency_format = this.options.moneyFormatCurrency;
    this.moneyFormats[this.options.shopCurrency].money_format = this.options.moneyFormatNoCurrency;
    this.isInitialised = true;

    this._current();
  },
  setCurrency: function setCurrency(newCurrency, isInitialised) {
    /**
    * Change the currency to a new currency using an ISO currency code
    *
    * @param {String} newCurrency - New currency to convert prices to
    */
    if (!window.currencyConverter.isInitialised) return;

    window.currencyConverter._convertAll(newCurrency);
  },
  update: function update(priceEl) {
    /**
    * Update a price on the page from shop currency to the active currency, and formatting
    *
    * @param priceEl {HTMLElement} - element containing price text, in the shop currency
    */
    if (!window.currencyConverter.isInitialised) return; // unset any stored previous conversions and the data-currency attribute itself

    var attributes = priceEl.attributes;

    for (var attr = 0; attr < attributes.length; attr++) {
      var attribute = attributes[attr];

      if (attribute.name.indexOf('data-currency') === 0) {
        priceEl.setAttribute(attribute.name, '');
      }
    }

    window.currencyConverter._convertEl(priceEl, window.currencyConverter.currentCurrency);
  },
  _getStoredCurrency: function _getStoredCurrency() {
    /**
    * Return the stored currency from the client's browser
    * @returns {String}
    * @private
    */
    try {
      return localStorage.getItem(window.currencyConverter.storage);
    } catch (error) {
      console.warn(error);
      return window.currencyConverter.options.defaultCurrency;
    }
  },
  _setStoredCurrency: function _setStoredCurrency(currency) {
    /**
    * Save the client's currency in localstorage for persistence across pages
    * and sessions
    * @param {String} currency
    * @private
    */
    try {
      localStorage.setItem(window.currencyConverter.storage, currency);
    } catch (error) {
      console.warn(error);
    }
  },
  _current: function _current() {
    /**
    * Update the currency switcher to the current currency
    * @private
    */
    var switchers = document.querySelectorAll(window.currencyConverter.options.switcherSelector);

    for (var i = 0; i < switchers.length; i += 1) {
      var switcher = switchers[i];
      var childrenEls = switcher.querySelectorAll('option');

      for (var j = 0; j < childrenEls.length; j += 1) {
        var optionEl = childrenEls[j];

        if (optionEl.selected && optionEl.value !== window.currencyConverter.currentCurrency) {
          optionEl.selected = false;
        }

        if (optionEl.value === window.currencyConverter.currentCurrency) {
          optionEl.selected = true;
        }
      }
    }

    window.currencyConverter._convertAll(window.currencyConverter.currentCurrency);
  },
  _convertEl: function _convertEl(priceEl, newCurrency) {
    /**
    * Converts an individual price to the new format
    *
    * @param {Element} priceEl - Node element containing price
    * @param {String} oldCurrency - Currency of element converting from
    * @param {String} newCurrency - Currency to convert to
    * @private
    */
    var oldCurrency = window.currencyConverter.options.shopCurrency; // If the amount has already been converted, we leave it alone.

    if (priceEl.getAttribute('data-currency') === newCurrency) {
      return;
    } // If we are converting to a currency that we have saved, we will use the saved amount.

    if (priceEl.getAttribute('data-currency-'.concat(newCurrency))) {
      priceEl.innerHTML = priceEl.getAttribute('data-currency-'.concat(newCurrency));
    } else {
      var oldFormat = window.currencyConverter.moneyFormats[oldCurrency][window.currencyConverter.options.displayFormat];
      var newFormat = window.currencyConverter.moneyFormats[newCurrency][window.currencyConverter.options.displayFormat];

      // Overwrite AUD currency format
      if (newCurrency == "AUD") {
        newFormat = '${{amount_no_decimals}} <span class="currency-country-code">AUD</span>';
        oldFormat = '${{amount_no_decimals}} <span class="currency-country-code">AUD</span>';
      }
      
      var moneyValue = getMoneyValue(priceEl);
      var centsValue = getCentsValue(moneyValue, oldFormat, oldCurrency); // Cents value is empty, but not 0. 0$ is a valid price, while empty is not

      if (centsValue === '') return;
      var cents = window.Currency.convert(centsValue, oldCurrency, newCurrency);
      var oldPriceFormatted = formatMoney(centsValue, oldFormat);
      var priceFormatted = formatMoney(cents, newFormat);

      if (!priceEl.getAttribute('data-currency-original')) {
        priceEl.setAttribute('data-currency-original', oldPriceFormatted);
      }

      priceEl.setAttribute("data-currency-".concat(oldCurrency), oldPriceFormatted);
      priceEl.setAttribute("data-currency-".concat(newCurrency), priceFormatted);
      priceEl.innerHTML = priceFormatted;
    }

    priceEl.setAttribute('data-currency', newCurrency);
  },
  _convertAll: function _convertAll(newCurrency) {
    /**
    * Convert all prices on the page to the new currency
    *
    * @param {String} oldCurrency - Currency of element converting from
    * @param {String} newCurrency - Currency to convert to
    * @private
    */

    // if custom theme currency converter is enabled, we'll convert all the prices, else we just need to convert the shipping calculator prices
    if (window.PXUTheme.currency.show_multiple_currencies) {
      var priceEls = document.querySelectorAll(window.currencyConverter.options.priceSelector);
    } else {
      var priceEls = document.querySelectorAll('#wrapper-response span.money, #estimated-shipping span.money');
    }

    if (!priceEls) return;
    window.currencyConverter.currentCurrency = newCurrency;
    $('.currency-code').text(window.currencyConverter.currentCurrency)

    window.currencyConverter._setStoredCurrency(newCurrency);

    // only if Shopify multi currency is disabled, run convertEl function
    for (var i = 0; i < priceEls.length; i += 1) {
      window.currencyConverter._convertEl(priceEls[i], newCurrency);
    }
  },
  convertCurrencies: function() {

    if (Currency.show_multiple_currencies) {
      var $currencySelector = $('.currency-code').first().text();
    } else {
      var $currencySelector = $('#CurrencySelector').first().val()
    }

    if ($currencySelector) {
      window.currencyConverter.setCurrency($currencySelector);
    }
  }
}
